import React from 'react';
import { Mail, HelpCircle, MessageCircle } from 'lucide-react';
import { Card } from '../common/Card';

export const ContactSection: React.FC = () => {
  return (
    <section className="bg-slate-50 dark:bg-slate-800 py-16">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-4">
            Get in Touch
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-300 max-w-2xl mx-auto">
            Questions about SleepCalc Pro? We're here to help you optimize your sleep.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <Card className="p-6 text-center hover:shadow-lg transition-shadow">
            <div className="flex justify-center mb-4">
              <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center">
                <Mail className="h-6 w-6 text-blue-600 dark:text-blue-400" />
              </div>
            </div>
            <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">
              General Support
            </h3>
            <p className="text-slate-600 dark:text-slate-300 text-sm mb-4">
              Technical issues, account questions, and general assistance
            </p>
            <a 
              href="mailto:support@sleepcalc.pro"
              className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 font-medium"
            >
              support@sleepcalc.pro
            </a>
          </Card>

          <Card className="p-6 text-center hover:shadow-lg transition-shadow">
            <div className="flex justify-center mb-4">
              <div className="w-12 h-12 bg-green-100 dark:bg-green-900 rounded-lg flex items-center justify-center">
                <MessageCircle className="h-6 w-6 text-green-600 dark:text-green-400" />
              </div>
            </div>
            <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">
              Billing & Refunds
            </h3>
            <p className="text-slate-600 dark:text-slate-300 text-sm mb-4">
              Subscription questions and refund requests
            </p>
            <a 
              href="mailto:refunds@sleepcalc.pro"
              className="text-green-600 dark:text-green-400 hover:text-green-700 dark:hover:text-green-300 font-medium"
            >
              refunds@sleepcalc.pro
            </a>
          </Card>

          <Card className="p-6 text-center hover:shadow-lg transition-shadow">
            <div className="flex justify-center mb-4">
              <div className="w-12 h-12 bg-purple-100 dark:bg-purple-900 rounded-lg flex items-center justify-center">
                <HelpCircle className="h-6 w-6 text-purple-600 dark:text-purple-400" />
              </div>
            </div>
            <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">
              Business Inquiries
            </h3>
            <p className="text-slate-600 dark:text-slate-300 text-sm mb-4">
              Partnerships, legal questions, and business matters
            </p>
            <a 
              href="mailto:legal@sleepcalc.pro"
              className="text-purple-600 dark:text-purple-400 hover:text-purple-700 dark:hover:text-purple-300 font-medium"
            >
              legal@sleepcalc.pro
            </a>
          </Card>
        </div>

        <div className="text-center mt-8">
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Response time: Within 24 hours • Available Monday-Friday, 9 AM - 6 PM EST
          </p>
        </div>
      </div>
    </section>
  );
};